export default "__VITE_ASSET__cac16dd0__"